<template>
	<div v-show="userPermissionsFilter.admin" :class="[companyClass, canScroll]" v-loading="pageLoading"
		element-loading-text="Loading..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<h2 class="text-white">Webapp Customers</h2>
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>Customer ID</th>
							<th>KYC Name</th>
							<th>Name</th>
							<th>Email</th>
							<th>Phone</th>
							<th>Nationality</th>
							<th>ID Number</th>
							<th>KYC Status</th>
							<th>Approver</th>
							<th>Comments</th>
							<th>Platform</th>
							<th>Transactions</th>
							<th>Details</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in usersdata" :key="item.userID">
							<td>{{ item.customerNumber }}</td>
							<td>{{ item.kycName }}</td>
							<td>{{ item.fullName }}</td>
							<td>{{ item.email }}</td>
							<td>{{ item.phoneNumber }}</td>
							<td>{{ item.nationality }}</td>
							<td>{{ item.idNumber }}</td>
							<td>{{ item.kycConfirmation }}</td>
							<td>{{ item.kycApprover }}</td>
							<td>{{ item.kycComments }}</td>
							<td>{{ item.platform }}</td>
							<td><a v-show="userPermissionsFilter.viewtransactions" @click="print(item)"><i
										class="mdi mdi-eye"></i></a> <span class="transactionsNo text-green">{{
											item.successTransactions }}</span> <span class="transactionsNo text-white">{{
										item.pendingTransactions }}</span> <span class="transactionsNo text-red">{{
										item.failedTransactions }}</span></td>
							<td><a :href="'UsersComplianceView/' + item.userID"><i class="mdi mdi-eye"></i></a></td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--
			<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible" @close="closeDialog"
							:before-close="handleClose">
								<div class="avatar-box">
									<img :src="'data:image/png;base64,'+userdata.picture" alt="user avatar" style="max-height: 100px;">

								</div>
								<div class="form-box">
									<div class="row">
										<div class="row">
											<div class="col col-md-12">
												<strong>Customer ID</strong>
												<el-input placeholder="Customer ID" v-model="userdata.customerNumber" name="customerNumber" v-validate="'required'" data-vv-as="customerNumber" :readonly="true"></el-input>
												<transition name="fade"><span class="danger-text">{{ errors.first('customerNumber') }}</span></transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Date Registered</strong>
												<el-input placeholder="Date Registered" v-model="userdata.createdOn" :readonly="true" @change="propertyChanged"
												name="createdOn" v-validate="'required'" data-vv-as="createdOn"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('createdOn') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>KYC Name</strong>
												<el-input placeholder="KycName" v-model="userdata.kycName" :readonly="true" @change="propertyChanged"
												name="KycName" v-validate="'required'" data-vv-as="KycName"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('KycName') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Full Name</strong>
												<el-input placeholder="FullName" v-model="userdata.fullName" :readonly="true" @change="propertyChanged"
												name="fullName" v-validate="'required'" data-vv-as="fullName"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('fullName') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Email</strong>
												<el-input placeholder="emailAddress" v-model="userdata.emailAddress" :readonly="true" @change="propertyChanged"
												name="email" v-validate="'required'" data-vv-as="emailAddress"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('emailAddress') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Phone Number</strong>
												<el-input placeholder="phoneNumber" v-model="userdata.phoneNumber" :readonly="true" @change="propertyChanged"
												name="phoneNumber" v-validate="'required'" data-vv-as="phoneNumber"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('phoneNumber') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Nationality</strong>
												<el-input placeholder="Nationality" v-model="userdata.nationality" :readonly="true" @change="propertyChanged"
												name="nationality" v-validate="'required'" data-vv-as="nationality"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('nationality') }}</span>
												</transition>
											</div>
										</div>

										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Date of Birth</strong>
												<el-input placeholder="DOB" v-model="userdata.dob" :readonly="readOnlyMode" @change="propertyChanged"
												name="dob" v-validate="'required|dob'" data-vv-as="dob"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('dob') }}</span>
												</transition>
											</div>
										</div>

										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>ID Number</strong>
												<el-input placeholder="ID Number" v-model="userdata.idNumber" :readonly="readOnlyMode" @change="propertyChanged"
												name="idNumber" v-validate="'required'" data-vv-as="idNumber"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('idNumber') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>KYC Status</strong>
												<el-input placeholder="kycConfirmation" v-model="userdata.kycConfirmation" :readonly="readOnlyMode" @change="propertyChanged"
												name="kycConfirmation" v-validate="'required'" data-vv-as="kycConfirmation"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('kycConfirmation') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>KYC Date</strong>
												<el-input placeholder="Kyc Done On" v-model="userdata.confirmedOn" :readonly="readOnlyMode" @change="propertyChanged"
												name="confirmedOn" v-validate="'required|confirmedOn'" data-vv-as="confirmedOn"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('confirmedOn') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
											<div class="col col-md-12">
												<strong>Approver</strong>
												<el-input placeholder="kycApprover" v-model="userdata.kycApprover" :readonly="readOnlyMode" @change="propertyChanged"
												name="kycApprover" v-validate="'required'" data-vv-as="kycApprover"></el-input>
												<transition name="fade">
													<span class="danger-text">{{ errors.first('kycApprover') }}</span>
												</transition>
											</div>
										</div>
										<div class="row mt-12">
									<div class="col col-md-12">
										<strong>Document Expiry Date</strong>
										<el-date-picker
										style="width: 100%"
										v-model="userdata.expiryDate"
										type="date"
										format="yyyy-MM-dd"
										:picker-options="{disabledDate: disableAllDatesBeforeToday}"
										placeholder="Document Expiry Date"
										name="expiryDate"
										data-vv-as="document expiry date"
										></el-date-picker>
										<transition name="fade">
											<span class="danger-text">{{ errors.first('expiryDate') }}</span>
										</transition>
									</div>
								</div>

								<div class="row mt-12">
									<div class="col col-md-12">
										<strong>Failure Reason <span :class="required">*</span></strong>
										<el-select
											v-model="failureReason"
											filterable
											clearable
											placeholder="Failure Reason"
											class="mb-10"
											style="width:100%"
											name="failureReason"
											v-validate="'required'"
											data-vv-as="Failure Reason"
											>
											<el-option
												v-for="failureR in failureReasons"
												:key="failureR"
												:label="failureR"
												:value="failureR"
											></el-option>
										</el-select>
										<transition name="fade">
											<span class="danger-text">{{ errors.first('failureReason') }}</span>
										</transition>
									</div>
								</div>
								<div class="row mt-12">
									<div class="col col-md-12">
										<strong>Other KYC Comments <span :class="required">*</span></strong>
										<el-input placeholder="input your comment" v-model="userdata.kycComments" name="kycComments" v-validate="'required'" data-vv-as="kycComments"></el-input>
										<transition name="fade">
											<span class="danger-text">{{ errors.first('kycComments') }}</span>
										</transition>
									</div>
								</div>
										<div class="row mt-12" style="margin-top: 20px;">
											<div class="col col-md-12">
												<a data-magnify="gallery" :data-caption="userdata.fullName" :href="IdProfile" >
												<img :src="IdProfile" alt="ID" style="max-height: 500px;height:auto;width: auto;max-width: 100%;">
												</a>
											</div>
										</div>

										<div class="row mt-12" v-show="userdata.id != null && userPermissionsFilter.viewuserscompliance">
											<div class="col col-md-12">
										<el-button type="warning" class="btn-group" style="width:30%" v-show="userPermissionsFilter.approveusers" @click="updateUserKyc">
											<i class="mdi mdi-account-check"></i><span> Update KYC</span>
										</el-button>
										<el-button type="danger" class="btn-group" style="width:30%" v-show="userPermissionsFilter.deactivateusers"  @click="deleteUsersProfiles">
											<i class="mdi mdi-delete"></i><span> Delete</span>
										</el-button>
										<el-button type="warning" class="btn-group" style="width:30%" v-show="userPermissionsFilter.rejectusers"  @click="rejectUsersProfiles">
											<i class="mdi mdi-cancel"></i><span> Reject</span>
										</el-button>
										<el-button type="success" class="btn-group" style="width:30%" v-show="userPermissionsFilter.approveusers" @click="approveUsersProfiles">
											<i class="mdi mdi-account-check"></i><span> Approve</span>
										</el-button>
									</div>
										</div>
									</div>
								</div>
			</el-dialog>
			-->
			<!-- edit customer KYC: mbuvi -->
			<!-- edit customer KYC: mbuvi -->
		</div>
	</div>
</template>

<script>
import moment from 'moment'

import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'WebAppCustomers',
	data: function () {
		return {
			usersdata: '',
			userdata: '',
			failureReasons: ["Wrong-Documents", "IPRS-Error", "Customer-Error", "System-Error"],
			failureReason: '',
			//IdProfile = "data:image/png;base64," + response.data;
		}
	},
	computed: {
		usersFiltered() {
			return this.users.filter(({ firstName, lastName, email, phoneNumber, companyId }) => (firstName + lastName + email + phoneNumber).toString().toLowerCase().indexOf(this.search.toString().toLowerCase()) !== -1)
		},
		contactsClass() {
			return this.pageWidth >= 870 ? 'large' : this.pageWidth >= 760 ? 'medium' : 'small'
		},
		readOnlyMode() {
			return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
		}
	},
	methods: {
		openDialog(row) {
			var imagePlaceholder =
				"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";
			if (row.picture == "Uploaded") {
				row.picture = imagePlaceholder;
			}
			this.userdata = row;
			this.dialogFormVisible = true
			this.getIdPicture(row.userID);
		},
		rejectUsersProfiles() {
			this.dialogFormVisible = false;
			this.disapproveUser(this.userdata.userID, this.failureReason)
				.then(result => {
					if (result) {
						this.successMessage('User has been Rejected.');
						this.getUsersProfiles();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		deleteUsersProfiles() {
			this.dialogFormVisible = false;
			if (confirm("Do you really want to delete?")) {
				this.deleteUserKYC(this.userdata.userID)
					.then(result => {
						if (result) {
							this.successMessage('User kyc has been Deleted.');
							this.getUsersProfiles();
						}
					})
					.catch(err => this.errorMessage('An error occured.'));
			}
		},
		approveUsersProfiles() {
			this.dialogFormVisible = false;
			var newDate = moment(String(this.userdata.expiryDate)).format('DD-MM-YYYY');
			this.approveUser(this.userdata.userID, this.userdata.kycComments, newDate, this.failureReason)
				//this.approveUser(this.userdata.userID, this.failureReason)
				.then(result => {
					if (result) {
						this.successMessage('User has been approved.');
						this.getUsersProfiles();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		print(row) {
			router.push(`/usertransactions/${row.userID}`);
		},
		refreshUsers() {
			this.startLoader("Getting User Transactions...");
			this.getAllCustomerProfiles()
				.then((result) => {
					this.usersdata = result.items;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			var tblDT = $('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					'print'
				],
				initComplete: function () {
					var api = this.api();
					api.columns(4).every(function () {
						var column = this;
						var select = $('<select><option value="">Filter Kyc Status</option></select>')
							.appendTo($(column.footer()).empty())
							.on('change', function () {
								var val = $.fn.dataTable.util.escapeRegex(
									$(this).val()
								);

								column
									.search(val ? '^' + val + '$' : '', true, false)
									.draw();
							});

						column.data().unique().sort().each(function (d, j) {
							select.append('<option value="' + d + '">' + d + '</option>')
						});
					});
				},
				/*columnDefs: [
				   {
					   targets: -1,
					   className: 'dt-body-right'
				   },
				  {
				   "render": function ( data, type, row ) {
					   var edit='<td></td>';
					   return edit;
					   },
					   "targets": 4,
				   },

			   ],
				*/
			});
			if (this.userPermissionsFilter.admin122) {
				tblDT.button(0).enable(true);
				tblDT.button(0).hide();
			} else {
				tblDT.button(0).enable(false);
				tblDT.button(0).show();
			}
		}
	},
	mounted() {
		//API Call

	},
	created() {
		this.refreshUsers();
	},
	mixins: [PermissionsMixins]
}

</script>

<style>
.transactionsNo {
	width: 25px;
	padding-right: 10px;
}

.text-green {
	color: green
}

.text-white {
	color: white
}

.text-red {
	color: red;
}

table.dataTable tbody tr {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}
</style>